import { Reveal } from "../components/Motion";
import { doctor } from "../lib/data";
import { Send, Phone, MapPin, Mail, ArrowRight } from "lucide-react";

export default function Booking() {
  return (
    <div data-testid="page-booking">
      <section className="pt-32 md:pt-40 pb-10">
        <div className="container-luxe">
          <Reveal>
            <div className="overline mb-6">Онлайн запис</div>
          </Reveal>
          <Reveal delay={0.05}>
            <h1 className="font-serif text-5xl md:text-7xl lg:text-[88px] leading-[0.95] tracking-tight max-w-4xl">
              Запишіться на візит
            </h1>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-8 text-warmGray text-lg max-w-2xl leading-relaxed">
              Запис здійснюється напряму через Telegram — найшвидший спосіб отримати
              відповідь і обрати зручний час візиту.
            </p>
          </Reveal>
        </div>
      </section>

      {/* Telegram Direct primary CTA */}
      <section className="pb-16 md:pb-24">
        <div className="container-luxe">
          <Reveal>
            <div className="relative overflow-hidden rounded-[2rem] bg-ink text-bone px-8 py-12 md:px-16 md:py-20 grid md:grid-cols-12 gap-8 items-center grain">
              <div className="md:col-span-8">
                <div className="overline text-bone/50 mb-5">Запис у Telegram</div>
                <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
                  Напишіть мені напряму
                  <br />в Telegram
                </h2>
                <p className="mt-6 text-bone/70 max-w-xl text-base md:text-lg leading-relaxed">
                  Особисте повідомлення — найшвидший спосіб записатись. Я відповідаю
                  впродовж години та допомагаю обрати зручну дату й час візиту.
                </p>
              </div>
              <div className="md:col-span-4 md:text-right">
                <a
                  data-testid="booking-telegram-cta"
                  href={doctor.telegram}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center justify-center gap-3 rounded-full bg-bone text-ink px-10 py-6 text-[11px] tracking-[0.28em] uppercase hover:bg-nude transition w-full md:w-auto"
                >
                  <Send size={18} strokeWidth={1.5} /> Telegram Direct
                </a>
                <div className="mt-5 text-bone/50 text-xs md:text-right">
                  {doctor.telegramHandle}
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      {/* Alternative contact options */}
      <section className="pb-24 md:pb-32">
        <div className="container-luxe">
          <Reveal>
            <div className="overline mb-3 text-warmGray">Альтернативні способи звʼязку</div>
            <h3 className="font-serif text-3xl md:text-4xl tracking-tight max-w-2xl">
              Або зателефонуйте напряму
            </h3>
          </Reveal>

          <div className="mt-12 grid md:grid-cols-3 gap-6 lg:gap-8">
            <Reveal>
              <a
                data-testid="booking-alt-phone"
                href={`tel:${doctor.phonesRaw[0]}`}
                className="block h-full p-8 md:p-10 rounded-3xl border border-line bg-sand/50 hover:bg-sand transition group"
              >
                <Phone size={26} strokeWidth={1.2} />
                <div className="overline mt-6 mb-2 text-warmGray">Телефон</div>
                <div className="font-serif text-2xl md:text-3xl tracking-tight">{doctor.phones[0]}</div>
                <div className="mt-2 text-sm text-warmGray">{doctor.phones[1]}</div>
                <div className="mt-6 inline-flex items-center gap-2 text-[11px] tracking-[0.28em] uppercase">
                  Зателефонувати
                  <ArrowRight size={14} strokeWidth={1.5} className="transition-transform group-hover:translate-x-1" />
                </div>
              </a>
            </Reveal>

            <Reveal delay={0.05}>
              <a
                data-testid="booking-alt-email"
                href={`mailto:${doctor.email}`}
                className="block h-full p-8 md:p-10 rounded-3xl border border-line bg-sand/50 hover:bg-sand transition group"
              >
                <Mail size={26} strokeWidth={1.2} />
                <div className="overline mt-6 mb-2 text-warmGray">Email</div>
                <div className="font-serif text-xl md:text-2xl tracking-tight break-all">{doctor.email}</div>
                <div className="mt-6 inline-flex items-center gap-2 text-[11px] tracking-[0.28em] uppercase">
                  Написати
                  <ArrowRight size={14} strokeWidth={1.5} className="transition-transform group-hover:translate-x-1" />
                </div>
              </a>
            </Reveal>

            <Reveal delay={0.1}>
              <a
                data-testid="booking-alt-maps"
                href={doctor.mapsLink}
                target="_blank"
                rel="noreferrer"
                className="block h-full p-8 md:p-10 rounded-3xl border border-line bg-sand/50 hover:bg-sand transition group"
              >
                <MapPin size={26} strokeWidth={1.2} />
                <div className="overline mt-6 mb-2 text-warmGray">Адреса клініки</div>
                <div className="text-base md:text-lg leading-relaxed">{doctor.address}</div>
                <div className="mt-6 inline-flex items-center gap-2 text-[11px] tracking-[0.28em] uppercase">
                  Прокласти маршрут
                  <ArrowRight size={14} strokeWidth={1.5} className="transition-transform group-hover:translate-x-1" />
                </div>
              </a>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
